// 중복 수업인지 확인
const checkDuplicateTime = (times1, times2) => {
    try {
        times1.forEach(time1 => {
            times2.forEach(time2 => {
                if (time1.day !== time2.day) {
                    return;
                }

                if (compareTime(time1.startHour, time1.startMinute, time2.endHour, time2.endMinute) < 0 &&
                    compareTime(time1.endHour, time1.endMinute, time2.startHour, time2.startMinute) > 0
                ) {
                    // forEach에 break가 없으므로 try-catch 사용
                    throw new Error();
                }
            });
        });
        return false;
    } catch (e) {
        return true;
    }
};

// 시간 비교 : 시간1이 시간2보다 빠를경우 마이너스
const compareTime = (hour1, minute1, hour2, minute2) => {
    if (hour1 !== hour2) {
        return hour1 - hour2;
    }

    return minute1 - minute2;
};

const getAvailableProgramsWhenAllowDuplicateApply = (programs) => {
    // 신청 완료 프로그램일 때 : program.answer = (object)
    const appliedPrograms = programs.filter(program => !!program.answer);

    if (appliedPrograms.length <= 0) {
        return programs;
    }

    let appliablePrograms = programs;
    appliedPrograms.forEach(applied => {
        let appliableProgramsTemp = [];
        appliablePrograms.find(program => {
            if (!checkDuplicateTime(applied.times, program.times) && !program.answer) {
                appliableProgramsTemp.push(program);
            }
        });
        appliablePrograms = appliableProgramsTemp;
    });

    return appliablePrograms;
};

export default {
    getAvailableProgramsWhenAllowDuplicateApply,
};
